import React from "react";
import { reduxForm, Field } from "redux-form";
import TextField from "@material-ui/core/TextField";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

let formModal = props => {
  const { handleSubmit, open, onClose, classes } = props;
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={open}
      onClose={onClose}
      className={classes.modal}
    >
      <div style={getModalStyle()} className={classes.paper}>
        <h4 className={classes.centeredTitle}>Apply For This Job</h4>
        <div className={classes.container}>
          <form className="form">
            <Field
              className={classes.input}
              name="full_name"
              component={renderField}
              type="text"
              label="Full Name"
            />
            <Field
              className={classes.input}
              name="email"
              component={renderField}
              type="email"
              label="Email Address"
            />
            <Field
              className={classes.input}
              name="current_job"
              component={renderField}
              type="text"
              label="Current Job Title"
            />

            {/* <Field
              className={classes.input}
              name="cover_letter"
              component={renderField}
              type="text"
              label="Cover Letter (Optional)"
              multiline={true}
              rows={3}
            /> */}

            <div className={classes.input}>
              <Typography variant="h6">Upload CV</Typography>
              <Field
                className={classes.input}
                name="cv"
                component={FileInput}
                type="file"
              />
            </div>

            {/* <div className={classes.input}>
              <Typography variant="h6">Upload Cover Letter</Typography>
              <Field
                className={classes.input}
                name="cover_letter"
                component={FileInput}
                type="file"
              />
            </div> */}

            <div className={classes.checkboxInput}>
              <div>
                <Field
                  name="yoma_employee"
                  id="yoma_employee"
                  component="input"
                  type="checkbox"
                />
              </div>
              <Typography variant="caption">
                I currently work for Yoma Group
              </Typography>
            </div>

            {/* <div className={classes.checkboxInput}>
              <div>
                <Field
                  name="acceptTnC"
                  id="acceptTnC"
                  component="input"
                  type="checkbox"
                />
              </div>
              <Typography variant="subheading">
                I accept the Terms and Conditions.
              </Typography>
            </div> */}

            <div className={classes.checkboxInput}>
              <div>
                <Field
                  name="other_jobs"
                  id="other_jobs"
                  component="input"
                  type="checkbox"
                />
              </div>
              <Typography variant="caption">
                Please consider me for other jobs.
              </Typography>
            </div>

            <div className="field">
              <div className="control">
                <Button
                  variant="contained"
                  disabled={!open}
                  component="span"
                  className="submit-btn"
                  onClick={handleSubmit}
                >Submit</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

const validate = val => {
  const errors = {};
  if (!val.full_name) {
   
    errors.full_name = "Full Name is required";
  }
  if (!val.email) {
    errors.email = "Email is required";
  } else if (!/^.+@.+$/i.test(val.email)) {
    errors.email = "Invalid email address";
  }
  if (!val.current_job) {
    errors.current_job = "Current Job Title is required";
  }
  if (!val.yoma_employee) {
    val.yoma_employee = false;
  }
  if (!val.other_jobs) {
    val.other_jobs = false;
  }
  if (!val.cv) {
    errors.cv = "CV is required";
  }
  // if (!val.acceptTnC || !val.acceptTnC === true) {
  //   errors.cv = "Please accept the Terms and Conditions to continue";
  // }
  return errors;
};

const FileInput = ({
  input: { value: omitValue, onChange },
  meta: { touched, error, warning },
  ...props
}) => {
  return (
    <div>
      <input
        onChange={adaptFileEventToValue(onChange)}
        // omitValue={omitValue}
        type="file"
        multiple
        {...props.input}
        {...props}
      />
      {touched &&
        ((error && <span style={{ color: "red" }}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
};

const adaptFileEventToValue = delegate => e => delegate(e.target.files);
//const adaptFileEventToValue = delegate => e => delegate(e.target.files);

const renderField = ({
  input,
  label,
  className,
  multiline,
  rows,
  type,
  meta: { touched, error, warning }
}) => (
    <div>
      <TextField
        className={className}
        {...input}
        label={label}
        type={type}
        variant="outlined"
        fullWidth
        multiline={multiline}
        rows={rows}
      />
      {touched &&
        ((error && <span style={{ color: "red" }}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );

formModal = reduxForm({
  form: "signIn",
  validate
})(formModal);

function getModalStyle() {
  // const top = 50;
  const left = 50;

  return {
    top: `0px`,
    left: `calc(${left}% - 189px)`
  };
}

export default formModal;
